import styled from 'styled-components';

const MyHomePlannerStyles = styled.article`
  position: relative;

  .completed-cta {
    position: relative;
    margin-top: 80px;
    input {
      background: white !important;
    }

    input:-webkit-autofill,
    input:-webkit-autofill:focus {
      background: white !important;
    }

    .phone-wrap {
      position: relative;
      text-align: left;
      margin-top: 10px;
    }
    .name-wrap {
      position: relative;
      text-align: left;
      margin-top: 10px;
      display: flex;
      gap: 20px;
      @media screen and (max-width: 540px) {
        flex-direction: column;
        gap: 10px;
      }
    }
    .animated {
      min-height: 0px !important;
    }
    .animated,
    .appointment-input {
      label,
      input,
      span {
        padding-left: 10px;
        color: #352269;
      }
      span {
        font-family: 'source-sans-pro';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        color: #352269;
      }
    }
    .appointment-wrap {
      position: relative;
      z-index: 999;
      display: flex;
      justify-content: center;
      margin-bottom: 20px;
      gap: 20px;
      text-align: left;
      padding: 0px 10px;

      @media screen and (max-width: 900px) {
        padding: 0px;
        flex-direction: column;
      }
      .appointment-column {
        position: relative;
        flex: 1 0 50%;
        min-width: 150px;
        @media screen and (max-width: 600px) {
          flex: 0 0 100%;
        }
        input {
          label {
            padding-left: 7px;
          }
        }
        .react-datepicker-wrapper {
          width: 100%;
        }
      }
    }
    .schedule-content {
      position: relative;
      margin-top: 20px;
      margin-bottom: 20px;
      text-align: left;
      h4 {
        font-family: 'source-sans-pro';
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: -0.35px;
        color: #352269;
      }
      p {
        font-family: 'source-sans-pro';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        color: #352269;
      }
    }
    .caption-wrap {
      position: relative;
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
    .caption {
      font-family: 'source-sans-pro';
      font-style: normal;
      font-weight: 400;
      font-size: 10px;
      line-height: 14px;
      display: flex;
      align-items: center;
      text-align: center;
      color: #352269;
      max-width: 100%;
    }
    .form-label,
    input {
      font-family: 'source-sans-pro';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 27px;
      letter-spacing: -0.35px;
      color: #352269;
    }
    .DXTextInput-note {
      font-family: 'source-sans-pro';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 27px;
      letter-spacing: -0.35px;
      color: #ef4b5d;
    }

    .CTAPlannerCard {
      padding-top: 40px;
      padding-bottom: 40px;
      overflow: inherit;
      .CTAPlannerCard-content {
        .CTAPlannerCard-heading {
          font-weight: 600 !important;
          font-size: 32px;
          line-height: 38px;
          letter-spacing: -0.35px;
          font-family: 'source-sans-pro';
          margin-top: 7px;
          margin-bottom: 10px;
        }
      }
      form {
        h3 {
          font-family: 'source-sans-pro';
          font-style: normal;
          font-weight: 600;
          font-size: 25px;
          line-height: 38px;
          letter-spacing: -0.35px;
          color: #352269;
          text-align: left;
        }
      }
    }
    .CTAPlannerCard-secondary {
      margin-bottom: 1rem !important;
    }
  }
  .edit-features-btn {
    position: relative;
    display: flex;
    align-items: center;
    text-decoration: none;
    color: #0075c9;
    width: 100%;
    justify-content: center;
    min-height: 74px;
    font-family: 'source-sans-pro';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #0075c9;
    gap: 5px;
    border: 1px solid #e4e5e7 !important;
    outline: none;
    transition: 0.2s;
    &:hover {
      background: rgba(0, 117, 201, 0.1);
    }
    @media screen and (max-width: 430px) {
      font-size: 12px;
    }
  }

  .container {
    max-width: 1138px;
    padding: 0px 40px;
    margin: 0 auto;
    @media screen and (max-width: 1099px) {
      padding: 0px 20px;
    }
  }

  .planner-overview-wrap {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 30px;
    margin-top: 80px;
    margin-bottom: 80px;
    z-index: 1;
    &:after {
      content: '';
      position: absolute;
      height: 100%;
      top: 0;
      left: 112px;
      width: 5px;
      background: #ffc50a;
      z-index: 0;
    }
  }

  //// Hero //////
  .DXHero {
    position: relative;
    @media screen and (min-width: 901px) {
      padding: 80px 0px;
    }
    @media screen and (max-width: 900px) {
      padding: 45px 0px;
    }
    .DXHero-backdrop {
      max-height: 70%;
      @media screen and (min-width: 900px) {
        max-height: none !important;
      }
    }
    .DXHero-container {
      max-width: 1138px;
      padding: 0px 40px;
      margin: 0 auto;
      @media screen and (max-width: 1099px) {
        padding: 0px 20px;
        width: 100%;
        max-width: 670px;
      }
      @media screen and (max-width: 900px) {
        width: 100%;
        max-width: 100%;
      }
      .DXIconCard {
        max-width: 685px;
      }

      .DXIconCard {
        position: relative;

        .DXIconCard-content {
          h1,
          h2,
          p {
            font-family: 'source-sans-pro';
          }
          h1 {
            font-weight: 600;
            font-size: 40px;
            line-height: 48px;
            margin: 0px 0px 10px 0px !important;
            font-family: 'source-sans-pro';
            @media screen and (max-width: 1099px) {
              font-weight: 600;
              font-size: 32px;
              line-height: 38px;
              letter-spacing: -0.35px;
            }
          }
          p {
            font-size: 18px;
            line-height: 29px;
            color: #4e5255;
          }
        }
        .DXIconCard-icon {
          @media screen and (min-width: 1100px) {
            top: -25px;
          }
          @media screen and (min-width: 900px) {
            top: -35px;
          }
        }
      }
    }
  }

  //// Planner Card/////
  .PlannerCard {
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
    z-index: 1;
    .PlannerCard-info {
      .PlannerCard-heading {
        font-weight: 600;
        font-size: 25px;
        line-height: 30px;
        font-family: 'source-sans-pro';
        letter-spacing: -0.35px;
      }
      .PlannerCard-subheading {
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 29px;
        margin-top: 4px;
      }
    }
  }

  /// CTA Planner Card /////
  .CTAPlannerCard {
    z-index: 1;
    width: 100%;
    .CTAPlannerCard-content {
      .CTAPlannerCard-heading {
        font-weight: 600;
        font-size: 32px;
        line-height: 38px;
        letter-spacing: -0.35px;
        font-family: 'source-sans-pro';
        margin-top: 7px;
      }
      .CTAPlannerCard-link {
        width: 64px;
        height: 64px;
      }
    }
    .DXChip {
      font-weight: 800;
      font-size: 12px;
      line-height: 12px;
      color: #ffffff;
    }
  }
  .cta-button {
    background: #0075c9;
    color: white;
    border-radius: 2px;
    padding: 17px 17px;
    font: 500 12px/100% 'source-sans-pro', sans-serif;
    margin-top: 22px;
    letter-spacing: 1px;
    text-decoration: none;
    transition: 0.2s;
    text-transform: uppercase;
    font-weight: 600;
    display: inline-flex;
    align-self: center;
    &:hover {
      background: rgb(23, 158, 255);
    }
  }

  .displayContents {
    display: contents;
  }

  .feature-answer-wrap {
    .FeaturesGrid-grid,
    .FeaturesGrid-mobileNav {
      @media screen and (max-width: 600px) {
        width: 100% !important;
      }
    }
    .FeaturesGrid-grid {
      @media screen and (max-width: 600px) {
        grid-template-columns: repeat(auto-fill, minmax(100%, 1fr)) !important;
        .FeatureCard-label {
          font-size: 14px !important;
          line-height: 1.2;
        }
      }
    }
  }
`;

export default MyHomePlannerStyles;
